import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useAuthStore } from "@/lib/auth/AuthStore";
import CheckLoginDialog from "../modal/CheckLoginDialog";
import useDialog from "@/hooks/useDialog";
export const LoginDialogProvider = (param)=>{
    let { children  } = param;
    const { isLoggedIn  } = useAuthStore();
    const { open , isOpen  } = useDialog();
    useEffect(()=>{
        if (!isLoggedIn) open();
    }, [
        isLoggedIn
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            /*#__PURE__*/ _jsx(CheckLoginDialog, {
                open: isOpen
            })
        ]
    });
};
